import { gpHome } from '../../app';
import { AccountsService } from '../../services/accounts-service';
import { IAuthService } from '../../services/auth-service';
import { ILogglyService } from '../../../app-common/services/jsloggly-service';
import { CurrentUserService } from '../../../app-common/services/current-user-service';
import signupTemplate from './signup.html';

class SignupController {
    static $inject = ['$location', 'authService', 'accountsService', 'gpLogglyService', CurrentUserService.serviceName];
    registered = false;
    loggingIn = false;
    message = '';
    readonly registration = {
        email: "",
        password: "",
        confirmPassword: "",
        comments: "",
        company: "",
        name: "",
    };

    constructor(private $location: ng.ILocationService, private authService: IAuthService, private accountsService: AccountsService, private logglyService: ILogglyService, private currentUserService: CurrentUserService) {
        gtag('event', "signup-show", {
            'event_category': 'registration',
            'event_label': "",
        });
    }

    signUp = () => {
        gtag('event', "signup", {
            'event_category': 'registration',
            'event_label': "",
        });

        this.authService.tryToRegisterNewUserSkipInvitation(this.registration)
            .then(() => {
                gtag('event', "signup-success", {
                    'event_category': 'registration',
                    'event_label': "",
                });

                this.accountsService.setAsNewlyRegisterdUser(this.registration.email, true);
                this.loggingIn = true;
                this.registered = true;
                this.message = '';
                this.login();
            })
            .catch(response => {
                let errors = [];

                if (response.data) {
                    for (let key in response.data.modelState) {
                        for (let i = 0; i < response.data.modelState[key].length; i++) {
                            errors.push(response.data.modelState[key][i]);
                        }
                    }
                }
                else {
                    errors.push('We were unable to contact the server.');
                }

                this.message = "Sign up failed. " + '\n' + errors.join('\n');
            });
    }

    private login = () => {
        gtag('event', "login", {
            'event_category': 'registration',
            'event_label': "",
        });

        this.logglyService.information("Login started for {UserEmail}", [this.registration.email], { ClientContext: 'SignupController' });

        this.authService.login(this.registration)
            .then(() => {
                gtag('event', "login-success", {
                    'event_category': 'registration',
                    'event_label': "",
                });

                // this triggers a check on the user id, which will register with google analytics
                this.currentUserService.getSubscriptionStatus().then(status => { });

                this.logglyService.information("Login success for {UserEmail}", [this.registration.email], { ClientContext: 'SignupController' });
                this.logglyService.information("Navigating to plan list", [], { controller: 'loginController' });
                // We use window.location.href instead of this.$location.path because we need to 
                // redirect to the server to check for payment and status. If all is well it will redirection to /#/welcome
                window.location.href = "/welcome";
            })
            .catch(err => {
                // Just log the error, we don't update the ui as it will be displaying the default email confirmation required message. 
                this.logglyService.information("Login failed for {UserEmail}", [this.registration.email], { ClientContext: 'SignupController' });
                this.loggingIn = false
                this.message = err.error_description;
            });
    }
}

gpHome.directive("gpSignup", [function (): ng.IDirective {
    return ({
        restrict: 'E',
        scope: {
        },
        controller: SignupController,
        controllerAs: 'vm',
        bindToController: true,
        template: signupTemplate,
    });
}]);

